var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.0282V0.00292969L15 8.51555V14.1906L5 8.51555V19.8657L0 17.0282Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.51555L30 0.00292969V17.0282L20 22.7033L15 19.8657L25 14.1906V8.51555L15 14.1906V8.51555Z",
    fill: "#0081CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19.8662V25.5413L25 31.2164V25.5413L15 19.8662Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 31.2159L40 22.7033V11.3531L35 14.1906V19.8657L25 25.5408V31.2159ZM35 8.51556V2.84047L40 0.00292969V5.67801L35 8.51556Z",
    fill: "#0081CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 31.2195,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuiLogo);
export default __webpack_public_path__ + "static/media/mui-logo.d91e927ffce00bd41961af06517a6f59.svg";
export { ForwardRef as ReactComponent };